var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column mt-2"},[_c('apexchart',{ref:"myChart",attrs:{"id":"myChart","type":"radar","height":"800","options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }